export const TIME_TO_SYNC_ESIGNATURE = 65000
